import localStorageUtil from '@/common/utils/localStorageUtil';
import Constant from '@/common/constant/Constant';
import {
    createNewTicketAPI, saveDraftTicketAPI,
} from '@/service/ticketService';
import { isExistUserInCorp } from '@/service/userService';
import trI18n from '@/common/utils/trI18n';
import { copyFileOfTicketDraftTo, handleUploadFilesForTicket } from '@/component/common/layout/addTicket/handler/AddTicketHandler';
import Utils from '@/common/utils/utils';
import { removePanelInitData } from '@/component/multiPanel/panel/handler/PanelHandler';
import { createKibanaDataContentOperation } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaLogAPI } from '@/service/logKibanaService';
import { updateUserWorkLastForm } from '@/common/utils/ServiceFactoryUtil';
import { validateExceedSizeOfFieldTicket } from '@/component/common/ValidateTicket';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

const externalCustomerProjectErrObj = {
    error: true,
    helperText: 'COMMSG001',
}

/**
 * onSubmitCreateInvitationGuestCustomerTicket
 * invite guest or guest customer
 * @param {*} argsAll 
 * @param {*} formData 
 * @param {*} userDetail 
 * @param {*} panelId 
 * @param {*} panelType 
 * @param {*} tabId 
 * @param {*} corporationDetail 
 * @param {*} formId 
 * @param {*} setError 
 * @param {*} ticketStatus 
 * @returns 
 */
export const onSubmitCreateInvitationGuestCustomerTicket = async (
    argsAll,
    formData,
    userDetail,
    panelId,
    panelType,
    tabId,
    corporationDetail,
    formId,
    setError,
    ticketStatus
) => {
    let customerEmail = formData.customerEmail;
    if (!customerEmail) {
        setError("customerEmail", {
            type: "manual",
            message: trI18n('COMMSG014'),
        });
        return;
    }

    argsAll.setIsLoading(true);

    customerEmail = customerEmail.trim();
    let isCustomerExistInCorp = await isExistUserInCorp(argsAll.API, customerEmail, corporationDetail.organizationDomain);

    if (isCustomerExistInCorp) {
        setError("customerEmail", {
            type: "manual",
            message: trI18n('COMMSG013'),
        });
        argsAll.setIsLoading(false);
        return;
    }

    let customerLastName = formData.customerLastName;
    let customerFirstName = formData.customerFirstName;
    let affiliationOrganization = corporationDetail.id;
    let affiliationProject = localStorageUtil.getSelectedProjectId();

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };

    if (formData[Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME]?.length) {
        uploadFileS3Result = await handleUploadFilesForTicket(
            formData,
            argsAll.setFileUploading,
            argsAll.fileUploadList
        );
    }

    
    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
    };

    const requestBody = {
        createTicketRequestDto: {
            type: formId,
            affiliationOrganization,
            affiliationProject,
            
            outline: formData?.outline,
            corporationOrigin: corporationDetail.id,
            corporationTarget: corporationDetail.id,
            projectOrigin: affiliationProject,
            description: formData?.description,
            createUserId: userDetail.id,
            ticketType: Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER,

            customerEmail,
            customerLastName,
            customerFirstName,
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.ARCHIVED,
            public: Constant.TICKET_PUBLIC.PUBLIC,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            ...draftTicketInfo
      
        },
    };

    const newTicket = await createNewTicketAPI(argsAll.API, requestBody);
    if (!newTicket?.id) {
        argsAll.setIsLoading(false);
        return;
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_INVITED,
        formId: formId,
        projectTargetId: formData?.projectTarget,
        corpTargetId: formData?.corporationTarget ? formData?.corporationTarget : argsAll?.corporationDetail?.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);

    argsAll.setIsLoading(false);
    if (!tabId) {
        tabId = argsAll.ticketId;
    }
    
    let lastUserAction = LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD;
    let usingFormName = Utils.convertJSONDataToObject(argsAll.selectedFormInfo.name)?.jp?.text;
    let dataLog = {
        rootCorporationDetail: argsAll.corporationDetail,
        rootProjectDetail: argsAll.projectInuseDetail,
        corporationDetail: argsAll.corporationDetail,
        projectDetail: argsAll.projectInuseDetail,
        userDetail: argsAll.userDetail,
        ticketDetail: {
            id: newTicket.id,
            outline: newTicket.outline,
            creator: newTicket.creator,
            usingFormName: usingFormName,
            createdAt: newTicket.createdAt,
        },
        metaData: {
            formDetailId: argsAll.selectedForm,
            ticketType: Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER
        },
        ticketCreationScreen: LogKibanaConstant.TICKET_CREATION_SCREEN.SOLUTIONDESK
    }
    let logKibanaData = createKibanaDataContentOperation(
        lastUserAction,
        dataLog
    );
    let param = {
        logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD,
        logKibanaData: logKibanaData
    };
    createKibanaLogAPI(argsAll.API, param);
    argsAll.setLastUserAction(null);
    removePanelInitData(panelId, tabId, argsAll.panelInitData, argsAll.setPanelInitData);
    argsAll.updatePanelAfterCreateTicket({
        panelId: panelId,
        tabId: tabId,
        panelType: panelType,
        ticketId: newTicket.id,
        ticketOutline: newTicket.outline,
        API: argsAll.API
    });
    
    argsAll.enqueueSnackbar(buildSnackbarMessage('MSG-CM-SEND-TICKET-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });
    return newTicket;
};


/**
 * onSaveDraftInvitationGuestCustomerTicketHandler
 * save draft invite guest or guest customer
 * @param {*} argsAll 
 * @param {*} formData 
 * @param {*} userDetail 
 * @param {*} corporationDetail 
 * @param {*} formId 
 * @returns 
 */
export const onSaveDraftInvitationGuestCustomerTicketHandler = async (
    argsAll,
    formData,
    userDetail,
    corporationDetail,
    formId
) => {
    argsAll.setIsLoading(true);

    let customerEmail = formData.customerEmail;
    customerEmail = customerEmail.trim();    
    
    let isCustomerExistInCorp = await isExistUserInCorp(argsAll.API, customerEmail, corporationDetail.organizationDomain);
    if (isCustomerExistInCorp) {
        argsAll.setErrorCreateTicket("customerEmail", {
            type: "manual",
            message: trI18n('COMMSG013'),
        });
        argsAll.setIsLoading(false);
        return;
    }

    let customerLastName = formData.customerLastName;
    let customerFirstName = formData.customerFirstName;
    let affiliationOrganization = corporationDetail.id;
    let affiliationProject = localStorageUtil.getSelectedProjectId();

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };

    if (formData[Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME]?.length) {
        uploadFileS3Result = await handleUploadFilesForTicket(
            formData,
            argsAll.setFileUploading,
            argsAll.fileUploadList
        );

    }

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
    };

    const requestBody = {
        createTicketRequestDto: {
            type: formId,
            affiliationOrganization,
            affiliationProject,
            
            outline: formData?.outline,
            corporationOrigin: corporationDetail.id,
            corporationTarget: corporationDetail.id,
            projectOrigin: affiliationProject,
            description: formData?.description,
            createUserId: userDetail.id,
            ticketType: Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER,

            customerEmail,
            customerLastName,
            customerFirstName,
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.ARCHIVED,
            public: Constant.TICKET_PUBLIC.PUBLIC,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            ...draftTicketInfo

        },
    };

    const newTicket = await saveDraftTicketAPI(argsAll.API, requestBody);
    if (!newTicket?.id) {
        argsAll.setIsLoading(false);
        return;
    }
    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_INVITED,
        formId: formId,
        projectTargetId: formData?.projectTarget,
        corpTargetId: formData?.corporationTarget ? formData?.corporationTarget : argsAll?.corporationDetail?.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);

    return newTicket;
};

/**
 * onSubmitCreateInviteExternalCustomerTicket
 * @param {*} argsAll 
 * @param {*} formData 
 * @param {*} panelId 
 * @param {*} panelType 
 * @param {*} tabId 
 * @returns 
 */
export const onSubmitCreateInviteExternalCustomerTicket = async (
    argsAll,
    formData,
    panelId,
    panelType,
    tabId,
) => {
    if (!argsAll.selectedForm ||
        Utils.isEmptyObject(argsAll.externalCustomerRequestProject) ||
        !argsAll.externalCustomerRequestProject?.value ||
        !argsAll.externalCustomerRequestProject?.corporationId
    ) {
        let errObj = {...externalCustomerProjectErrObj};
        errObj.helperText = 'COMMSG014';
        argsAll.setExternalCustomerProjectErr(errObj);
        argsAll.setIsLoading(false);
        return;
    }

    argsAll.setIsLoading(true);

    let requestBody = {};
    const fields = await Utils.getCustomFieldValueInFormData(formData, argsAll.fieldListData);
    const statusField = argsAll.fieldListData.find((fieldData) => fieldData.type === Constant.FORM_TYPE.FIELD_WORKFLOW);
    let status = '';
    if(!Utils.isEmptyObject(statusField)){
        status = statusField.fieldId;
    }

    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, fields, argsAll.setErrorMessageHeader)) {
        argsAll.setIsLoading(false);
        return;
    }

    // External customer request invitation
    let ticketType = Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER;
    let selectedForm = formData.selectedForm ? formData.selectedForm : argsAll.selectedForm;
    let corporationOrigin = argsAll.corporationDetail.id;
    let projectOrigin = argsAll.projectInuseDetail.id;
    let corporationTarget = argsAll.externalCustomerRequestProject.corporationId;
    let projectTarget = argsAll.externalCustomerRequestProject.value;
    
    let affiliationOrganization = corporationOrigin;
    let affiliationProject = projectOrigin;
    let customer = projectTarget;
    let inviteAndApproveStatus = {};

    formData.corporationTarget = corporationTarget;
    formData.projectTarget = projectTarget;
    inviteAndApproveStatus.invitationFlag = Constant.INVITATION_FLAG.WAITING_APPROVE;
    inviteAndApproveStatus.approveFlag = Constant.APPROVE_FLAG.INPROCESS;
    
    const uploadFileS3Result  = await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading,
        argsAll.fileUploadList
    );

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
    };

    requestBody = {
        createTicketRequestDto: {
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.PUBLIC,
            outline: formData?.outline,
            description: formData?.description,
            createUserId: argsAll.userDetail.id,
            corporationOrigin: corporationOrigin,
            projectOrigin: projectOrigin,
            projectTarget: [projectTarget],
            corporationTarget: corporationTarget,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            ticketType,
            type: selectedForm,
            affiliationOrganization,
            affiliationProject,
            status,
            customer,
            fields,

            // External customer request status
            ...inviteAndApproveStatus,
            ...draftTicketInfo
        },
    };

    const newTicket = await createNewTicketAPI(argsAll.API, requestBody);
    if (!newTicket?.id) {
        if (!newTicket.createTicketStatus && newTicket?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            argsAll.setIsOpenModalReloadPage(true);
        }

        argsAll.setIsLoading(false);
        return;
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_INVITED,
        formId: selectedForm,
        projectTargetId: formData?.projectTarget,
        corpTargetId: formData?.corporationTarget ? formData?.corporationTarget : argsAll?.corporationDetail?.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);

    argsAll.setIsLoading(false);
    argsAll.enqueueSnackbar(buildSnackbarMessage('MSG-CM-SEND-TICKET-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000,
    });

    let lastUserAction = LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD;
    let usingFormName = Utils.convertJSONDataToObject(argsAll.selectedFormInfo.name)?.jp?.text;
    let dataLog = {
        rootCorporationDetail: {
            id: newTicket.affiliationOrganization
        },
        rootProjectDetail: {
            id: newTicket.affiliationProject
        },
        corporationDetail: argsAll.corporationDetail,
        projectDetail: argsAll.projectInuseDetail,
        userDetail: argsAll.userDetail,
        ticketDetail: {
            id: newTicket.id,
            outline: newTicket.outline,
            creator: newTicket.creator,
            usingFormName: usingFormName,
            createdAt: newTicket.createdAt,
        },
        metaData: {
            formDetailId: argsAll.selectedForm,
            ticketType: Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER
        },
        ticketCreationScreen: LogKibanaConstant.TICKET_CREATION_SCREEN.SOLUTIONDESK
    }
    let logKibanaData = createKibanaDataContentOperation(
        lastUserAction,
        dataLog
    );
    let param = {
        logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD,
        logKibanaData: logKibanaData
    };
    createKibanaLogAPI(argsAll.API, param);
    argsAll.setLastUserAction(null);
    if (!tabId) {
        tabId = argsAll.ticketId;
    }
    removePanelInitData(panelId, tabId, argsAll.panelInitData, argsAll.setPanelInitData);
    argsAll.updatePanelAfterCreateTicket({
        panelId: panelId,
        tabId: tabId,
        panelType: panelType,
        ticketId: newTicket.id,
        ticketOutline: newTicket.outline,
        API: argsAll.API
    });
    
    return;
};


export const onSaveDraftInviteExternalCustomerTicket = async (
    argsAll,
    formData,
    panelId,
    panelType,
    tabId,
) => {
    if (!argsAll.selectedForm ||
        Utils.isEmptyObject(argsAll.externalCustomerRequestProject) ||
        !argsAll.externalCustomerRequestProject?.value ||
        !argsAll.externalCustomerRequestProject?.corporationId
    ) {
        let errObj = {...externalCustomerProjectErrObj};
        errObj.helperText = 'COMMSG014';
        argsAll.setExternalCustomerProjectErr(errObj);
        argsAll.setIsLoading(false);
        return;
    }

    argsAll.setIsLoading(true);

    let requestBody = {};
    const fields = await Utils.getCustomFieldValueInFormData(formData, argsAll.fieldListData);
    const statusField = argsAll.fieldListData.find((fieldData) => fieldData.type === Constant.FORM_TYPE.FIELD_WORKFLOW);
    let status = '';
    if(!Utils.isEmptyObject(statusField)){
        status = statusField.fieldId;
    }

    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, fields, argsAll.setErrorMessageHeader)) {
        argsAll.setIsLoading(false);
        return;
    }

    // External customer request invitation
    let ticketType = Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER;
    let selectedForm = formData.selectedForm ? formData.selectedForm : argsAll.selectedForm;
    let corporationOrigin = argsAll.corporationDetail.id;
    let projectOrigin = argsAll.projectInuseDetail.id;
    let corporationTarget = argsAll.externalCustomerRequestProject.corporationId;
    let projectTarget = argsAll.externalCustomerRequestProject.value;
    
    let affiliationOrganization = corporationOrigin;
    let affiliationProject = projectOrigin;
    let customer = projectTarget;
    let inviteAndApproveStatus = {};

    formData.corporationTarget = corporationTarget;
    formData.projectTarget = projectTarget;
    inviteAndApproveStatus.invitationFlag = Constant.INVITATION_FLAG.WAITING_APPROVE;
    inviteAndApproveStatus.approveFlag = Constant.APPROVE_FLAG.INPROCESS;

    const uploadFileS3Result = await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading,
        argsAll.fileUploadList
    );

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
    };

    requestBody = {
        createTicketRequestDto: {
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.DRAFT,
            outline: formData?.outline,
            description: formData?.description,
            createUserId: argsAll.userDetail.id,
            corporationOrigin: corporationOrigin,
            projectOrigin: projectOrigin,
            projectTarget: [projectTarget],
            corporationTarget: corporationTarget,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            ticketType,
            type: selectedForm,
            affiliationOrganization,
            affiliationProject,
            status,
            customer,
            fields,

            // External customer request status
            ...inviteAndApproveStatus,
            ...draftTicketInfo
        },
    };

    const newTicket = await saveDraftTicketAPI(argsAll.API, requestBody);
    if (!newTicket?.id) {
        let errList = newTicket?.errors;
        let msgCode = !Utils.isEmptyArray(errList) ? errList[0]?.message : '';
        if (msgCode) {
            argsAll.enqueueSnackbar(buildSnackbarMessage(msgCode), {
                variant: 'error',
                autoHideDuration: 3000,
            });
        }

        argsAll.setIsLoading(false);
        return;
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_INVITED,
        formId: selectedForm,
        projectTargetId: formData?.projectTarget,
        corpTargetId: formData?.corporationTarget ? formData?.corporationTarget : argsAll?.corporationDetail?.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);

    // argsAll.enqueueSnackbar(trI18n('USER04MSG025'), {
    //     variant: 'success',
    //     autoHideDuration: 3000,
    // });

    // argsAll.updatePanelAfterCreateTicket({
    //     panelId: panelId,
    //     tabId: tabId,
    //     panelType: panelType,
    //     ticketId: newTicket.id,
    //     ticketOutline: newTicket.outline,
    //     API: argsAll.API
    // });
    return newTicket;
};